import { Fragment, ReactNode } from 'react'

export type ItemRender<Item> = (item: Item, index: number) => ReactNode

export function renderArray<Item>(items: Item[], item: ItemRender<Item>, separator?: ItemRender<Item>) {
  const end = items.length - 1
  return items.map((it, index) => <Fragment key={index}>
    {item(it, index)}
    {index < end && separator && separator(it, index)}
  </Fragment>)
}
